interface FindShortlistedFlightJourneysArgs {
  onewayFares: ReadonlyArray<ReadonlyArray<App.JourneyV2>>
  departingJourneyKey: string | undefined
  returningJourneyKey?: string
}

interface FindShortlistedFlightJourneysResult {
  departingJourney?: App.JourneyV2
  returningJourney?: App.JourneyV2
}

export function findShortlistedFlightJourneys({
  onewayFares,
  departingJourneyKey,
  returningJourneyKey,
}: FindShortlistedFlightJourneysArgs): FindShortlistedFlightJourneysResult {
  const allFares = onewayFares.flat()
  const departingFares = onewayFares[0] ?? []
  const returningFares = onewayFares[1] ?? []

  const departingJourney = departingJourneyKey
    ? departingFares.find(journey => journey.bookingInfo.journeyKey === departingJourneyKey)
    ?? allFares.find(journey => journey.bookingInfo.journeyKey === departingJourneyKey)
    : undefined
  const returningJourney = returningJourneyKey
    ? returningFares.find(journey => journey.bookingInfo.journeyKey === returningJourneyKey)
    ?? allFares.find(journey => journey.bookingInfo.journeyKey === returningJourneyKey)
    : undefined

  return {
    departingJourney,
    returningJourney,
  }
}
